// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090604/js/" + chunkId + "." + {"44":"6560ca96","225":"1b95957c","481":"880c85f1","486":"fbc52ef3","770":"7f5cdc8c"}[chunkId] + ".0.14259369041294478.chunk.js";
};